import {getCatalog} from '../../api/builds'

export const state = {
  storeList: [],
  buildTypeList: [],
  artifactTypeList: [],
  projectList: [],
  architectureList: []
}

export const getters = {
  storeList: (state) => state.storeList,
  buildTypeList: (state) => state.buildTypeList,
  artifactTypeList: (state) => state.artifactTypeList,
  projectList: (state) => state.projectList,
  architectureList: (state) => state.architectureList
}

export const mutations = {
  SET_STORE_LIST (state, value) {
    state.storeList = value
  },
  SET_BUILD_TYPE_LIST (state, value) {
    state.buildTypeList = value
  },
  SET_ARTIFACT_TYPE_LIST (state, value) {
    state.artifactTypeList = value
  },
  SET_PROJECT_LIST (state, value) {
    state.projectList = value
  },
  SET_ARCHITECTURE_LIST (state, value) {
    state.architectureList = value
  }
}

export const actions = {
  getArtifactType ({commit}, {site, data}) {
    return getCatalog({site: site, catalog: 'artifact_type', data: data})
      .then((response) => {
        commit('SET_ARTIFACT_TYPE_LIST', response.data)
      })
  },

  getStore ({commit}, {site, data}) {
    return getCatalog({site: site, catalog: 'store', data: data})
      .then((response) => {
        commit('SET_STORE_LIST', response.data)
      })
  },

  getBuildType ({commit}, {site, data}) {
    return getCatalog({site: site, catalog: 'build_type', data: data})
      .then((response) => {
        commit('SET_BUILD_TYPE_LIST', response.data)
      })
  },

  getProjects ({commit}, {site, data}) {
    return getCatalog({site: site, catalog: 'project', data: data})
      .then((response) => {
        commit('SET_PROJECT_LIST', response.data)
      })
  },

  getArchitecture ({commit}, {site, data}) {
    return getCatalog({site: site, catalog: 'architecture', data: data})
      .then((response) => {
        commit('SET_ARCHITECTURE_LIST', response.data)
      })
  }
}
